module.exports = __webpack_public_path__ + "static/media/comment-music.71fcdd9b.svg";